import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/batches";

export const fetchBatches = createAsyncThunk("batch/fetchBatches", async (params?: string): Promise<any> => {
  const query = params ? `?${params}` : "";
  const response = await axios.get(`${BASE}/list${query}`);
  return response.data; // { data, total }
});

export const updateBatch = createAsyncThunk("batch/updateBatch", async ({ id, payload }: any): Promise<any> => {
  const response = await axios.put(`${BASE}/${id}`, payload);
  return response.data;
});
